const questions = document.querySelectorAll('.faq-question');
const answers = document.querySelectorAll('.faq-answer');

let i = 1;
for (let q of questions) {
  q.setAttribute('data-question-number', i);
  answers[i - 1].setAttribute(`data-answer-number-${i}`, '');
  i++;
}

questions.forEach(q => {
  q.addEventListener('click', e => {
    let question = e.target.closest('.faq-question');
    // if (!question.hasAttribute('data-question-number'))
    let questionNumber = question.getAttribute('data-question-number');
    console.log(`Question number ${questionNumber}`);
    let answer = document.querySelector(
      `[data-answer-number-${questionNumber}]`
    );
    let toggle = question.querySelector('.faq-toggle');
    // console.log('Answer element: ', answer);
    answer.classList.toggle('open');
    toggle.classList.toggle('open');
  });
});

// answers.forEach(a => {
//   let pNode = document.createElement('p');
//   let text = a.innerText;
//   pNode.innerText = text;
//   a.innerText = '';
//   a.appendChild(pNode);
// });
